import { APIRequestState } from 'api';
import { Recipe } from 'common/hooks/useProducer';
import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import {
  NotificationRemoveActions,
  NotificationRetrieveActions,
  UpdateEmailActions,
  UpdatePasswordActions,
} from './actions';
import { NotificationState } from './states';

/**
 * The recipe required by useProducer to transform the APIRequestState
 * This recipe handles retrieving the current notifications
 */
export const notificationRetrieveRecipe: Recipe<
  NotificationState,
  NotificationRetrieveActions
> = (draft, action) => {
  switch (action.type) {
    case 'notification/retrieve/started':
      draft.pending = true;
      return;
  }
  switch (action.type) {
    case 'notification/retrieve/finished':
      draft.pending = false;
      draft.notifications = action.notifications;
      draft.error = action.error;
      return;
  }
};

/**
 * The recipe required by useProducer to transform the APIRequestState
 * This recipe handles removing a notifications
 */
export const notificationRemoveRecipe: Recipe<
  APIRequestState,
  NotificationRemoveActions
> = (draft, action) => {
  switch (action.type) {
    case 'notification/remove/started':
      draft.pending = true;
      return;
  }
  switch (action.type) {
    case 'notification/remove/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;
  }
};

/**
 * The recipe required by useProducer to transform the APIRequestState
 * This recipe handles updating the email of the logged in account
 */
export const updateEmailRecipe: Recipe<APIRequestState, UpdateEmailActions> = (
  draft,
  action
) => {
  switch (action.type) {
    case 'self/email/update/started':
      draft.pending = true;
      return;

    case 'self/email/update/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

/**
 * The recipe required by useProducer to transform the APIRequestState
 * This recipe handles updating the password of the logged in account
 */
export const updatePasswordRecipe: Recipe<
  APIRequestState,
  UpdatePasswordActions
> = (draft, action) => {
  switch (action.type) {
    case 'self/password/update/started':
      draft.pending = true;
      return;

    case 'self/password/update/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
